import { EditActionDefinition } from '@wix/editor-platform-host-integration-apis';

import {
  PlatformContext,
  CustomManifestAction,
  EditActionsDictionary,
} from '../types';
import { filterByTags, resolveCustomActionsWithFactories } from '../utils';
import { convertCustomActionToExecutableFactory } from './actionHandlers';
import { getCustomActionsOverrides } from './getCustomActionsOverrides';

export const getCustomEditActions = (
  platformContext: PlatformContext,
  tags?: string[],
): EditActionDefinition[] => {
  const { componentsAPI, editorPointer } = platformContext;

  const customManifestActions: EditActionsDictionary<CustomManifestAction> =
    componentsAPI.get.customActions(
      editorPointer,
    ) as EditActionsDictionary<CustomManifestAction>;

  const customOverrideActions = getCustomActionsOverrides(
    platformContext,
    editorPointer,
  );

  const customActions = {
    ...customManifestActions,
    ...customOverrideActions,
  };

  if (!customActions || Object.keys(customActions).length === 0) {
    return [];
  }

  const customActionsFactories =
    convertCustomActionToExecutableFactory(customActions);
  const resolvedCustomActions = resolveCustomActionsWithFactories(
    customActionsFactories,
    customActions,
    platformContext,
  );
  return filterByTags(resolvedCustomActions, tags);
};
